import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiMail, FiLock, FiKey } from 'react-icons/fi';
import api from '../api/client';

export default function RecuperarContrasena() {
    const navigate = useNavigate();
    const [paso, setPaso] = useState(1);
    const [correo, setCorreo] = useState('');
    const [codigo, setCodigo] = useState('');
    const [nuevaContrasena, setNuevaContrasena] = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [error, setError] = useState('');
    const [exito, setExito] = useState('');
    const [cargando, setCargando] = useState(false);

    const solicitarCodigo = async (e) => {
        e.preventDefault();
        setError(''); setExito('');
        if (!correo) { setError('Ingresa tu correo'); return; }
        setCargando(true);
        try {
            await api.post('/auth/recuperar-contrasena', { correo });
            setExito('Si el correo existe, te enviamos un codigo');
            setTimeout(() => setPaso(2), 1000);
        } catch (err) {
            if (!err.response) {
                setError('No se puede conectar al servidor. Verifica que el backend este corriendo.');
            } else {
                setError(err.response?.data?.error || `Error ${err.response.status}`);
            }
        } finally {
            setCargando(false);
        }
    };

    const verificarCodigo = async (e) => {
        e.preventDefault();
        setError(''); setExito('');
        if (!codigo) { setError('Ingresa el codigo'); return; }
        setCargando(true);
        try {
            await api.post('/auth/verificar-codigo-recuperacion', { correo, codigo });
            setPaso(3);
        } catch (err) {
            if (!err.response) setError('No se puede conectar al servidor.');
            else setError(err.response?.data?.error || 'Codigo invalido');
        } finally {
            setCargando(false);
        }
    };

    const cambiarContrasena = async (e) => {
        e.preventDefault();
        setError(''); setExito('');
        if (nuevaContrasena.length < 4) { setError('Contrasena muy corta'); return; }
        if (nuevaContrasena !== confirmar) { setError('Las contrasenas no coinciden'); return; }
        setCargando(true);
        try {
            await api.post('/auth/cambiar-contrasena', { correo, codigo, nuevaContrasena });
            setExito('Contrasena cambiada. Redirigiendo al login...');
            setTimeout(() => navigate('/login'), 1500);
        } catch (err) {
            if (!err.response) setError('No se puede conectar al servidor.');
            else setError(err.response?.data?.error || `Error ${err.response.status}`);
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-card">
                <div className="auth-logo"><FiKey /></div>
                <h1 className="auth-title">Recuperar Contrasena</h1>
                <p className="auth-subtitle">
                    {paso === 1 && 'Ingresa tu correo para recibir un codigo'}
                    {paso === 2 && 'Ingresa el codigo que te enviamos'}
                    {paso === 3 && 'Define tu nueva contrasena'}
                </p>

                {error && <div className="error-msg">{error}</div>}
                {exito && <div className="exito-msg">{exito}</div>}

                {paso === 1 && (
                    <form onSubmit={solicitarCodigo}>
                        <div className="form-group">
                            <div className="input-icono">
                                <FiMail className="icono" size={16} />
                                <input
                                    className="input"
                                    type="email"
                                    placeholder="Correo electronico"
                                    value={correo}
                                    onChange={e => setCorreo(e.target.value)}
                                />
                            </div>
                        </div>
                        <button type="submit" className="btn btn-primario btn-bloque" disabled={cargando}>
                            {cargando ? 'Enviando...' : 'Enviar codigo'}
                        </button>
                    </form>
                )}

                {paso === 2 && (
                    <form onSubmit={verificarCodigo}>
                        <div className="form-group">
                            <input
                                className="input"
                                type="text"
                                placeholder="Codigo de 6 digitos"
                                value={codigo}
                                onChange={e => setCodigo(e.target.value)}
                                maxLength="6"
                                style={{ textAlign: 'center', letterSpacing: '6px', fontSize: 18 }}
                            />
                        </div>
                        <button type="submit" className="btn btn-primario btn-bloque" disabled={cargando}>
                            {cargando ? 'Verificando...' : 'Continuar'}
                        </button>
                    </form>
                )}

                {paso === 3 && (
                    <form onSubmit={cambiarContrasena}>
                        <div className="form-group">
                            <div className="input-icono">
                                <FiLock className="icono" size={16} />
                                <input
                                    className="input"
                                    type="password"
                                    placeholder="Nueva contrasena"
                                    value={nuevaContrasena}
                                    onChange={e => setNuevaContrasena(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="input-icono">
                                <FiLock className="icono" size={16} />
                                <input
                                    className="input"
                                    type="password"
                                    placeholder="Confirmar contrasena"
                                    value={confirmar}
                                    onChange={e => setConfirmar(e.target.value)}
                                />
                            </div>
                        </div>
                        <button type="submit" className="btn btn-primario btn-bloque" disabled={cargando}>
                            {cargando ? 'Guardando...' : 'Cambiar contrasena'}
                        </button>
                    </form>
                )}

                <div className="auth-link">
                    <Link to="/login">Volver al login</Link>
                </div>
            </div>
        </div>
    );
}
